import _0x142e34 from'./setGrabCursor.js';import _0x40d8cb from'./unsetGrabCursor.js';export default{'setGrabCursor':_0x142e34,'unsetGrabCursor':_0x40d8cb};